module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.c2bf54b.woff";